import axios from './axiosInstance';

export const servercheck = (query) => {
  return axios.get('/riot/livechk', {
    params: { userId: query }
  });
};


export const getMatchData_old = (query, offset = 0) => {
  return axios.get('/riot/matchlisttest', {
    params: { userId: query, offset },
  });
};


export const getMatchData = ({ nm_user, tag_user }, offset = 0, lastEndTime = null) => {
  const params = {
    nm_user,
    tag_user,
    offset,
  };

  return axios.get('/riot/summoner/search', { params });
};


export const updateMatchData = (puuid, endTime = null) => {
  return axios.get('/riot/summoner/update', {
    params: { puuid, endTime},
  });
};


export const getSearchMore = ({ nm_user, tag_user, puuid, lastStTime} ) => {
  const params = {
    nm_user,
    tag_user,
    puuid,
    lastStartTime:lastStTime
  };

  return axios.get('/riot/summoner/searchMore', { params });
};


export const insertUser = (userData) => {
  return axios.post('/riot/user/insertUser', userData);
};


export const userLogin = (userData) => {
  return axios.post('/riot/user/login', userData);
};

//export const netmarbleCoupon = (couponCode, pid) => {
//  return axios.get('/netmarble/coupon', {
//    params: { couponCode, pid},
//  });
export const netmarbleCoupon = (playerId, codes, workers = 5) => {
  return axios.post('/netmarble/coupon/', {
    playerId,
    codes,      // ✅ 배열
    workers,    // ✅ 선택
  });
};

// PUID × 쿠폰 전체 조합을 드라이버 1회 세션으로 처리
// items: [{ playerId, code }, ...]
export const netmarbleCouponBatch = (items) => {
  return axios.post('/netmarble/coupon/new/', items, { timeout: 0 });
};